import React from "react";

interface SpinnerProps {
  className?: string;
  label?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ className = "h-6 w-6", label }) => {
  return (
    <span className={`inline-flex items-center justify-center ${label ? "gap-2" : ""}`}>
      <span
        className={`animate-spin rounded-full border-2 border-slate-600 border-t-cyan-400 ${className}`}
        aria-hidden
      />
      {label && <span className="text-sm text-slate-400">{label}</span>}
    </span>
  );
};

export default Spinner;
